import React from 'react';
import { useHistory } from 'react-router-dom';
import { DoLogout } from 'services/authentication';
import {
    ModalOverlay,
    ModalContainer,
    ModalHeader,
    ModalTitle,
    ModalContent,
    ModalText,
    ModalActions,
    ModalButton,
    ModalIcon
} from './styled';

const SubscriptionExpiredModal = ({ 
    isOpen = true, 
    title = "Assinatura Expirada",
    message = "Sua assinatura expirou ou foi cancelada. Para continuar usando o TiqChat, você precisa renovar seu plano. Qualquer dúvida, entre em contato pelo WharsApp 92 98216-8732",
    showRenewButton = true,
    showPlansButton = true
}) => {
    const history = useHistory();
    
    const navigate = (path) => {
        history.push(`/${path}`);
    };

    const handleLogoutAndRedirect = async () => {
        await DoLogout();
        history.push('/');
    };

    if (!isOpen) return null;

    return (
        <ModalOverlay>
            <ModalContainer>
                <ModalHeader>
                    <ModalIcon>⚠️</ModalIcon>
                    <ModalTitle>{title}</ModalTitle>
                </ModalHeader>
                
                <ModalContent>
                    <ModalText>{message}</ModalText>
                </ModalContent>
                
                <ModalActions>
                    {showRenewButton && (
                        <ModalButton primary onClick={() => navigate('dashboard/sign')}>
                            Renovar Assinatura
                        </ModalButton>
                    )}
                    
                    {/* {showPlansButton && (
                        <ModalButton secondary onClick={() => navigate('planos')}>
                            Ver Planos
                        </ModalButton>
                    )} */}
                    
                    <ModalButton outline onClick={handleLogoutAndRedirect}>
                        Voltar ao Início
                    </ModalButton>
                </ModalActions>
            </ModalContainer>
        </ModalOverlay>
    );
};

export default SubscriptionExpiredModal;
